import React from 'react';
import { Card, CardContent, Box, Divider, Skeleton } from '@mui/material';

const MovementCardSkeleton = () => {

    return (
        <Card>
            <CardContent>
                {/* Card content info */}
                <Box ml={2} >
                    <Skeleton variant='rectangle' width="200px" height="20px" />
                    <Box sx={{ m: 1 }} />
                    <Skeleton />
                </Box>
            </CardContent>
        </Card>
    );
};

export default MovementCardSkeleton;